class MultiDiscountManager {
  constructor() { this.storageKey = 'gimme5_discount_codes'; }
  getSavedCodes() { try { return JSON.parse(localStorage.getItem(this.storageKey)) || []; } catch(e) { return []; } }
  saveCodes(codes) { localStorage.setItem(this.storageKey, JSON.stringify(codes)); }
  addCode(code) { const codes = this.getSavedCodes(); const upper = code.trim().toUpperCase(); if (!codes.includes(upper)) { codes.push(upper); this.saveCodes(codes); } }
  removeCode(code) { const upper = code.trim().toUpperCase(); this.saveCodes(this.getSavedCodes().filter(c => c !== upper)); }
  getCheckoutUrl() { const codes = this.getSavedCodes(); return codes.length === 0 ? '/checkout' : '/checkout?discount=' + codes.join(','); }
}
const discountManager = new MultiDiscountManager();

class DiscountCodeContent extends HTMLElement {
  connectedCallback() {
    this.applyBtn = this.querySelector('[data-apply-discount]');
    this.codeInput = this.querySelector('[data-discount-code]');
    this.feedback = this.querySelector('[data-discount-feedback]');
    if (this.applyBtn) this.applyBtn.addEventListener('click', this.handleApply.bind(this));
    this.querySelectorAll('[data-remove-code]').forEach(btn => {
      btn.addEventListener('click', (e) => { discountManager.removeCode(e.currentTarget.dataset.removeCode); this.refreshCart(); });
    });
  }
  async handleApply() {
    const code = this.codeInput ? this.codeInput.value.trim() : '';
    if (!code) { this.showFeedback('Please enter a discount code.', false); return; }
    this.showFeedback('Applying...', null);
    try {
      await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' });
      const cart = await (await fetch('/cart.js')).json();
      const applied = cart.cart_level_discount_applications &&
        cart.cart_level_discount_applications.some(d => d.title.toUpperCase() === code.toUpperCase());
      if (applied) {
        discountManager.addCode(code);
        if (this.codeInput) this.codeInput.value = '';
        this.showFeedback('✓ ' + code.toUpperCase() + ' applied!', true);
        this.refreshCart();
      } else { this.showFeedback('Invalid or inapplicable discount code.', false); }
    } catch(e) { this.showFeedback('Network error. Please try again.', false); }
  }
  showFeedback(msg, success) {
    if (!this.feedback) return;
    this.feedback.classList.remove('hidden');
    this.feedback.textContent = msg;
    this.feedback.style.color = success === true ? 'green' : success === false ? 'red' : '#666';
  }
  refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer?.dataset.url) return;
    fetch(cartDrawer.dataset.url).then(r => {
      if (!r.ok) throw new Error(`Cart refresh failed: ${r.status}`);
      return r.text();
    }).then(html => {
      const drawerHTML = cartDrawer.getSectionHTML(html);
      if (drawerHTML == null) return;
      cartDrawer.innerHTML = drawerHTML;
      cartDrawer.setupDialogEvents();
      cartDrawer.querySelectorAll('[data-drawer-close]').forEach(btn => btn.addEventListener('click', cartDrawer.closeDrawer.bind(cartDrawer)));
      const priceEl = document.querySelector('[data-cart-price]');
      if (priceEl) freeShippingBarProgress(parseInt(priceEl.dataset.cartPrice));
    }).catch(e => console.error(e));
  }
}
if (!customElements.get('discount-code-content')) {
  customElements.define('discount-code-content', DiscountCodeContent);
}

class CartDrawer extends HTMLElement {
  constructor() { super(); this.bindEvents(); document.addEventListener('keydown', this.handleEscapeKeyPress.bind(this)); }
  bindEvents() {
    const drawerBtn = document.querySelector('[data-cart-drawer]');
    if (drawerBtn) drawerBtn.addEventListener('click', this.openCartDrawer.bind(this));
    this.querySelectorAll('[data-close-drawer]').forEach(b => b.addEventListener('click', this.closeDrawer.bind(this)));
    this.setupDialogEvents();
  }
  setupDialogEvents() {
    let lastFocused = '';
    Array.from(this.querySelectorAll('.modal-dialog-button')).forEach(openBtn => {
      openBtn.addEventListener('click', () => {
        const dialog = this.querySelector('cart-dialog#' + openBtn.dataset.modal);
        if (dialog) { setTimeout(() => { dialog.classList.add('is-visible'); setTimeout(() => { lastFocused = openBtn; trapFocusElements(dialog); }, 600); }, 500); }
      });
    });
    Array.from(this.querySelectorAll('[data-dialog-close]')).forEach(closeBtn => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeBtn.closest('cart-dialog')?.classList.remove('is-visible');
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof trapFocusElements === 'function') trapFocusElements(drawer);
        setTimeout(() => { if (lastFocused) lastFocused.focus(); lastFocused = ''; }, 400);
      });
    });
  }
  openCartDrawer(event) {
    event?.preventDefault();
    if (!this.dataset.url) return;
    fetch(this.dataset.url).then(r => {
      if (!r.ok) throw new Error(`Cart drawer request failed: ${r.status}`);
      return r.text();
    }).then(html => {
      const drawerHTML = this.getSectionHTML(html);
      if (drawerHTML == null) return;
      this.innerHTML = drawerHTML;
      this.classList.add('is-visible');
      document.body.classList.add('overflow-hidden');
      this.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', this.closeDrawer.bind(this)));
      setTimeout(() => {
        focusElement = event?.target || null;
        if (typeof trapFocusElements === 'function') trapFocusElements(this);
      }, 500);
      const totalPrice = this.querySelector('#cart-drawer-body-content')?.getAttribute('data-cart-price');
      if (totalPrice != null && typeof freeShippingBarProgress === 'function') {
        freeShippingBarProgress(totalPrice);
      }
      this.setupDialogEvents();
    }).catch(e => console.error(e));
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach(section => {
      const destination = document.querySelector(section.selector);
      const sectionHTML = parsedState?.sections?.[section.id];
      if (!document.getElementById(section.id) || !destination || !sectionHTML) return;
      const drawerHTML = this.getSectionHTML(sectionHTML);
      if (drawerHTML == null) return;
      destination.innerHTML = drawerHTML;
      const parsedDrawer = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const totalCount = parsedDrawer.querySelector('#cart-drawer-body-content')?.getAttribute('data-cart-count');
      const priceEl = document.querySelector('[data-cart-price]');
      if (priceEl && typeof freeShippingBarProgress === 'function') {
        freeShippingBarProgress(parseInt(priceEl.dataset.cartPrice));
      }
      const itemCountEl = document.querySelector('[data-item-count]');
      if (itemCountEl && totalCount != null) {
        itemCountEl.classList.remove('hidden');
        if (totalCount == 0) itemCountEl.classList.add('hidden');
        else if (totalCount < 100) itemCountEl.textContent = totalCount;
        else itemCountEl.textContent = '99+';
      }
      if (typeof trapFocusElements === 'function') trapFocusElements(this);
      this.setupDialogEvents();
      this.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', this.closeDrawer.bind(this)));
    });
  }
  getSectionsToRender() { return [{ id: 'cart-drawer', section: 'cart-drawer', selector: 'cart-drawer' }]; }
  getSectionHTML(html) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer')?.innerHTML ?? null;
  }
  closeDrawer(event) {
    event?.preventDefault();
    if (this.classList.contains('is-visible')) {
      this.classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
    }
    if (focusElement?.focus) focusElement.focus();
    focusElement = '';
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }
  handleEscapeKeyPress(event) { if (event.key === 'Escape') this.closeDrawer(event); }
}
customElements.define('cart-drawer', CartDrawer);

document.addEventListener('click', (e) => {
  if (e.target.closest('#checkoutCart')) { e.preventDefault(); window.location.href = discountManager.getCheckoutUrl(); }
});

(function() {
  if (document.getElementById('gimme5-discount-styles')) return;
  const s = document.createElement('style'); s.id = 'gimme5-discount-styles';
  s.textContent = '.auto-discount-badge{font-size:10px;background:#e8f5e9;color:#2e7d32;padding:1px 6px;border-radius:3px;margin-left:4px;vertical-align:middle}.remove-discount-code-btn{background:none;border:none;cursor:pointer;color:#aaa;font-size:12px;margin-left:4px;padding:0 2px;vertical-align:middle}.remove-discount-code-btn:hover{color:#e53935}.discount-tag-row{display:flex;align-items:center;gap:4px;margin:2px 0}';
  document.head.appendChild(s);
})();
